export const enAgentGuiReferencePicker = {
  directoryPicker: {
    confirm: "Select folder",
    emptySearch: "No matching folders",
    searchPlaceholder: "Search folders",
    title: "Select project folder"
  },
  referencePicker: {
    clearFilter: "Clear filter",
    confirm: "Use references",
    emptyDirectory: "This folder is empty.",
    emptyPreview: "Select a file to see details",
    emptySearch: "No matching files or folders.",
    fileTypeAll: "All types",
    fileTypeDocument: "Documents",
    fileTypeImage: "Images",
    fileTypeOther: "Other",
    fileTypeSeparator: ", ",
    fileTypeVideo: "Videos",
    fileTypeWebpage: "Web pages",
    loadMore: "Load more",
    loadMoreGroups: "Load more",
    loading: "Loading...",
    loadError: "Couldn't load this content. Try again later.",
    previewBinary: "This file looks like binary content.",
    previewDecodeFailed: "This file couldn't be decoded as UTF-8 text.",
    previewError: "Couldn't load a preview.",
    previewFileTooLarge: "This file is larger than {{maxSize}}.",
    previewFolder: "Folder preview is not available.",
    previewHierarchy: "Location",
    previewLoading: "Loading preview...",
    previewModified: "Produced at",
    previewSize: "Size",
    previewSource: "Source",
    previewTextTooLarge: "This text file is larger than {{maxSize}}.",
    previewTooLarge: "This file is too large to preview.",
    previewUnavailable: "Preview is not available in this workspace.",
    previewUnsupported: "This file type can't be previewed here.",
    searchPlaceholder: "Search files and folders",
    selectGroupHint: "Select a folder on the left",
    selectedCount: "{{count}} selected",
    sourceColumn: "Category",
    title: "Pick workspace references"
  }
} as const;
